import { Btn } from "./Bits";
import { SectionHead, Reveal } from "./Reveal";
import { Contours, GnssMarker } from "./Vectors";

export const FinalCta = ({ title = ["Have survey data ready", "for CAD drafting?"], text = "Share your project requirements and available files with GEO DRAFTING. We will review the scope and discuss suitable deliverables." }) => (
  <section className="on-dark relative overflow-hidden bg-[#102A43] py-24 md:py-32 text-white" data-testid="final-cta-section">
    <Contours className="absolute -right-32 -top-32 w-[900px] text-[#5AA9E6] opacity-20" />
    <GnssMarker className="absolute left-[8%] bottom-10 w-24 text-[#D8B66A] opacity-30" />
    <div className="relative mx-auto max-w-[1400px] px-5 sm:px-8">
      <SectionHead dark eyebrow="Next step" title={title} intro={text} className="max-w-4xl" />
      <Reveal delay={0.2} className="mt-10 flex flex-wrap gap-4">
        <Btn to="/get-started" variant="gold" testid="final-cta-get-started-button">Get Started</Btn>
        <Btn to="/contact" variant="ghost" testid="final-cta-contact-button">Contact Our Team</Btn>
      </Reveal>
    </div>
  </section>
);
